"use client";

import React from "react";

export interface WhyChooseCard {
  title: string;
  subtitle?: string;
  icon: React.ReactNode;
  bgColor: string;
  content: React.ReactNode;
  footer?: React.ReactNode;
}

export interface WhyChooseCardsProps {
  title: string;
  subtitle?: string;
  description?: string;
  cards: WhyChooseCard[];
}

export function WhyChooseCards({
  title,
  subtitle,
  description,
  cards
}: WhyChooseCardsProps) {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 via-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {title}
          </h2>
          {subtitle && (
            <p className="text-xl font-medium text-gray-700 mb-3">{subtitle}</p>
          )}
          {description && (
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              {description}
            </p>
          )}
        </div>
        
        <div className="grid lg:grid-cols-3 gap-6 lg:gap-8">
          {cards.map((card, idx) => (
            <div key={idx} className="group relative">
              <div 
                className="relative rounded-3xl p-8 h-full shadow-md hover:shadow-lg transition-all duration-300"
                style={{ backgroundColor: card.bgColor }}
              >
                <div className="flex flex-col h-full">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-white/90 rounded-2xl flex-shrink-0">
                      {card.icon}
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900">{card.title}</h3>
                      {card.subtitle && (
                        <p className="text-sm text-gray-500 mt-1">{card.subtitle}</p>
                      )}
                    </div>
                  </div>
                  
                  <div className="flex-1">
                    {card.content}
                  </div>
                  
                  {card.footer && (
                    <div className="mt-auto pt-6 border-t border-gray-200/50">
                      {card.footer}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}